/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { lazy } from 'react';

// public routes >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>
const HomePage = lazy(() => import('../pages/public/home'));
const FAQ = lazy(() => import('../pages/public/static/FAQ'));
const AboutUs = lazy(() => import('../pages/public/static/AboutUs'));
const ContactUs = lazy(() => import('../pages/public/static/ContactUs'));
const SubscriptionPage = lazy(() => import('../pages/public/static/Subscription'));
const Administrative = lazy(() => import('../pages/public/products/Administrative'));
const ElectricityVending = lazy(() => import('../pages/public/products/ElectricityVending'));
const SecurityAccessControl = lazy(() => import('../pages/public/products/SecurityAccessControl'));
const IssuesAndCommunication = lazy(() => import('../pages/public/products/IssuesAndCommunication'));

// auth routes >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>
const AuthPage = lazy(() => import('../pages/auth'));
const LoginPage = lazy(() => import('../pages/auth/login'));
const ResetPage = lazy(() => import('../pages/auth/reset'));
const NotFoundPage = lazy(() => import('../pages/auth/404'));
const LogoutPage = lazy(() => import('../pages/auth/logout'));
const ForgotPage = lazy(() => import('../pages/auth/forgot'));
const SecurityPage = lazy(() => import('../pages/auth/security'));

// main routes >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>
const DashboardPage = lazy(() => import('../pages/main/dashboard'));
const BillingPage = lazy(() => import('../pages/main/billing'));
const VendingPage = lazy(() => import('../pages/main/vending'));
const VisitorsPage = lazy(() => import('../pages/main/visitors'));
const WalletPage = lazy(() => import('../pages/main/wallet'));
const ComplaintPage = lazy(() => import('../pages/main/complaint'));
const TransactionsPage = lazy(() => import('../pages/main/transactions'));
const SettingsPage = lazy(() => import('../pages/main/settings'));
const ProcessPage = lazy(() => import('../pages/main/process'));

// security routes >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>
const SecurityDashboardPage = lazy(() => import('../pages/security/dashboard'));
const SecurityPassPage = lazy(() => import('../pages/security/pass'));
const SecurityTicketPage = lazy(() => import('../pages/security/ticket'));
const SecuritySettingsPage = lazy(() => import('../pages/security/settings'));
const SecurityVisitorsHistoryPage = lazy(() => import('../pages/security/visitors'));

export type RouteProps = {
  path: string;
  label: string;
  component: any;
  description?: string;
};

export const routes: RouteProps[] = [
  // public pages with page initial path >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>
  {
    path: '/',
    label: 'Home',
    component: <HomePage />,
  },
  {
    path: '/page/facility',
    label: 'Facility Management Solution',
    component: <Administrative />,
  },
  {
    path: '/page/residential',
    label: 'Estate Plus Platform',
    component: <ElectricityVending />,
  },
  {
    path: '/page/visitor',
    label: 'Visitor management System',
    component: <SecurityAccessControl />,
  },
  {
    path: '/page/communication',
    label: 'Communication Management',
    component: <IssuesAndCommunication />,
  },
  {
    path: '/page/about',
    label: 'About us',
    component: <AboutUs />,
  },
  {
    path: '/page/faq',
    label: 'Frequently Asked Questions',
    component: <FAQ />,
  },
  {
    path: '/page/contact',
    label: 'Reach out to us',
    component: <ContactUs />,
  },
  {
    path: '/page/subscription',
    label: 'Subscribe to Estate Plus',
    component: <SubscriptionPage />,
  },


  // auth pages with auth initial path >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>
  {
    path: '*',
    label: 'Not Found',
    component: <NotFoundPage />,
  },
  {
    path: '/auth',
    label: 'Auth Page',
    component: <AuthPage />,
  },
  {
    path: '/auth/login',
    label: 'Login Page',
    component: <LoginPage />,
  },
  {
    path: '/auth/security',
    label: 'Security Login Page',
    component: <SecurityPage />,
  },
  {
    path: '/auth/logout',
    label: 'Logout Page',
    component: <LogoutPage />,
  },
  {
    path: '/auth/forgot',
    label: 'Forgot Page',
    component: <ForgotPage />,
  },
  {
    path: '/auth/reset',
    label: 'Reset Page',
    component: <ResetPage />,
  },


  // main pages with no initial path >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>
  {
    path: '/dashboard',
    label: 'Dashboard',
    component: <DashboardPage />,
    description: 'Welcome back to your account 👋🏻',
  },
  {
    path: '/billings',
    label: 'Billings',
    component: <BillingPage />,
    description: 'Your billing history in display 📊',
  },
  {
    path: '/vending',
    component: <VendingPage />,
    label: 'Electricity Vending',
    description: 'All vending activities in display ⚡',
  },
  {
    path: '/visitors',
    label: 'Visitors',
    component: <VisitorsPage />,
    description: 'All visitation activities in display 👥',
  },
  {
    path: '/wallet',
    label: 'Wallet',
    component: <WalletPage />,
    description: 'Wallet stats and activity history 👛',
  },
  {
    path: '/complaints',
    label: 'Tickets & Complains',
    component: <ComplaintPage />,
    description: 'All ticket stats and activity history 🎫',
  },
  {
    path: '/transactions',
    label: 'Transactions',
    component: <TransactionsPage />,
    description: 'All transaction history in display 🧾',
  },
  {
    path: '/settings',
    label: 'Settings',
    component: <SettingsPage />,
    description: 'All setting actions ⚙️',
  },
  {
    path: '/process',
    label: 'Payment Process',
    component: <ProcessPage />,
    description: 'Complete payment process ✅',
  },


  // security pages with no security path >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>
  {
    path: '/security/dashboard',
    label: 'Security Dashboard',
    component: <SecurityDashboardPage />,
  },
  {
    path: '/security/pass',
    label: 'Security Gate Pass',
    component: <SecurityPassPage />,
  },
  {
    path: '/security/ticket',
    label: 'Security Parking Ticket',
    component: <SecurityTicketPage />,
  },
  {
    path: '/security/settings',
    label: 'Security Settings',
    component: <SecuritySettingsPage />,
  },
  {
    path: '/security/visitors',
    label: 'Security Visitors History',
    component: <SecurityVisitorsHistoryPage />,
  },
];
